export const FETCH_USER_INFO = 'HOME:FETCH_USER_INFO';
export const FETCH_USER_INFO_SUCCESS = 'HOME:FETCH_USER_INFO_SUCCESS';
export const FETCH_USER_INFO_ERROR = 'HOME:FETCH_USER_INFO_ERROR';
export const FETCH_USER_BALANCE_ERROR = 'HOME:FETCH_USER_BALANCE_ERROR';
export const START_RECEIVE_DATA = 'HOME:START_RECEIVE_DATA';
export const RECEIVE_DATA = 'HOME:RECEIVE_DATA';
export const UPDATE_MNP_STATUS_VISIBILITY = 'HOME:UPDATE_MNP_STATUS_VISIBILITY';

export const MNP_STATUS_VISIBILITY_KEY = 'HOME:IS_MNP_STATUS_HIDDEN';

export const OPEN_VALIDATION_PD_POPUP = 'HOME:OPEN_VALIDATION_PD_POPUP';
export const CLOSE_VALIDATION_PD_POPUP = 'HOME:CLOSE_VALIDATION_PD_POPUP';
export const START_VALIDATION_PD_REQUEST = 'HOME:START_VALIDATION_PD_REQUEST';
export const SUCCESS_VALIDATION_PD_REQUEST = 'HOME:SUCCESS_VALIDATION_PD_REQUEST';
export const FAIL_VALIDATION_PD_REQUEST = 'HOME:FAIL_VALIDATION_PD_REQUEST';
export const SET_PARTNERSHIP_TARIFF_STATUS = 'HOME:SET_PARTNERSHIP_TARIFF_STATUS';

export const FETCH_USIS_RESULT_POPUP_DATA = 'FETCH_USIS_RESULT_POPUP_DATA';
export const SET_USIS_RESULT_STEP = 'HOME:SET_USIS_RESULT_STEP';
export const OPEN_USIS_RESULT_POPUP = 'HOME:OPEN_USIS_RESULT_POPUP';
export const CLOSE_USIS_RESULT_POPUP = 'HOME:CLOSE_USIS_RESULT_POPUP';

export const SET_ALLINONE_VALUE = 'SET_ALLINONE_VALUE';
export const FETCH_FAMILY_DATA = 'FETCH_FAMILY_DATA';
export const FETCH_FAMILY_LOADING = 'FETCH_FAMILY_LOADING';
export const FETCH_FAMILY_ERROR = 'FETCH_FAMILY_ERROR';

export const FETCH_USER_TARIFFS_BLOCK = 'HOME:FETCH_USER_TARIFFS_BLOCK';

export const FETCH_USER_TARIFFS_BLOCK_ENDPOINT = '/api/profile/homeinternet/mainblockinfo/';

export const ALLINONE_GET_REGION_ENDPOINT = '/region/getsuggestions/';
export const ALLINONE_GET_STREET_ENDPOINT = '/checkconnection/GetStreets/';
export const ALLINONE_GET_HOUSE_ENDPOINT = '/checkconnection/GetHouses/';
export const ACCEPT_OFFER_ALLINONE_REQUEST_ENDPOINT = '/api/profile/homeinternet/acceptMulticonvergenceOffer/';
export const USIS_RESULT_POPUP_ENDPOINT = '/api/texts/usis-result-popup/';

export const MOBILE_SERVICES_LINK = '/customers/products/elk/tab/mobile-connection/';
export const CONVERGENCE_SERVICES_LINK = '/customers/products/elk/tab/mobile-connection/';
export const POSTPAID_SERVICES_LINK = '/customers/products/mobile/profile/#/services ';
